import { render, staticRenderFns } from "./PageSuperadmins.vue?vue&type=template&id=31c2ffaa"
import script from "./PageSuperadmins.vue?vue&type=script&lang=js"
export * from "./PageSuperadmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports